export const countryList: string[] = [
  'af',
  'eg',
  'ax',
  'al',
  'dz',
  'as',
  'vi',
  'um',
  'ad',
  'ao',
  'ai',
  'aq',
  'ag',
  'gq',
  'ar',
  'am',
  'aw',
  'ac',
  'az',
  'et',
  'au',
  'bs',
  'bh',
  'bd',
  'bb',
  'by',
  'be',
  'bz',
  'bj',
  'bm',
  'bt',
  'bo',
  'bq',
  'ba',
  'bw',
  'br',
  'vg',
  'io',
  'bn',
  'bg',
  'bf',
  'bi',
  'cv',
  'ea',
  'cl',
  'cn',
  'ck',
  'cr',
  'ci',
  'cw',
  'dk',
  'de',
  'dg',
  'dm',
  'do',
  'dj',
  'ec',
  'sv',
  'er',
  'ee',
  'fk',
  'fo',
  'fj',
  'fi',
  'fr',
  'gf',
  'pf',
  'tf',
  'ga',
  'gm',
  'ge',
  'gh',
  'gi',
  'gd',
  'gr',
  'gl',
  'gp',
  'gu',
  'gt',
  'gg',
  'gn',
  'gw',
  'gy',
  'ht',
  'hn',
  'in',
  'id',
  'iq',
  'ir',
  'ie',
  'is',
  'im',
  'il',
  'it',
  'jm',
  'jp',
  'ye',
  'je',
  'jo',
  'ky',
  'kh',
  'cm',
  'ca',
  'ic',
  'kz',
  'qa',
  'ke',
  'kg',
  'ki',
  'cc',
  'co',
  'km',
  'cg',
  'cd',
  'xk',
  'hr',
  'cu',
  'kw',
  'la',
  'ls',
  'lv',
  'lb',
  'lr',
  'ly',
  'li',
  'lt',
  'lu',
  'mg',
  'mw',
  'my',
  'mv',
  'ml',
  'mt',
  'ma',
  'mh',
  'mq',
  'mr',
  'mu',
  'yt',
  'mx',
  'fm',
  'mc',
  'mn',
  'me',
  'ms',
  'mz',
  'mm',
  'na',
  'nr',
  'np',
  'nc',
  'nz',
  'ni',
  'nl',
  'ne',
  'ng',
  'nu',
  'kp',
  'mp',
  'mk',
  'nf',
  'no',
  'om',
  'at',
  'pk',
  'ps',
  'pw',
  'pa',
  'pg',
  'py',
  'pe',
  'ph',
  'pn',
  'pl',
  'pt',
  'pr',
  'md',
  're',
  'rw',
  'ro',
  'ru',
  'sb',
  'zm',
  'ws',
  'sm',
  'st',
  'sa',
  'se',
  'ch',
  'sn',
  'rs',
  'sc',
  'sl',
  'zw',
  'sg',
  'sx',
  'sk',
  'si',
  'so',
  'hk',
  'mo',
  'es',
  'sj',
  'lk',
  'bl',
  'sh',
  'kn',
  'lc',
  'mf',
  'pm',
  'vc',
  'za',
  'sd',
  'gs',
  'kr',
  'ss',
  'sr',
  'sz',
  'sy',
  'tj',
  'tw',
  'tz',
  'th',
  'tl',
  'tg',
  'tk',
  'to',
  'tt',
  'ta',
  'td',
  'cz',
  'tn',
  'tr',
  'tm',
  'tc',
  'tv',
  'ug',
  'ua',
  'hu',
  'uy',
  'uz',
  'vu',
  'va',
  've',
  'ae',
  'us',
  'gb',
  'vn',
  'wf',
  'cx',
  'eh',
  'cf',
  'cy',
]
